import SimpleDate from 'app/common/classes/simple-date'
import styles from './TimeCell.module.scss'

interface Props {
  time: SimpleDate
}
export const TimeCell = ({ time }: Props) => {
  return (
    <div className={styles.container}>
      <div>{time.getString('DD.MM.YYYY')}</div>
      <div>{time.getString('HH:mm')}</div>
    </div>
  )
}
